var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "reveal-gate-box",
      class: _vm.tight ? "reveal-gate-box-tight mt-2 mb-1" : "mb-3",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between",
          staticStyle: { gap: "12px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "small reveal-gate-text",
              staticStyle: { "line-height": "1.35" },
            },
            [_vm._t("default")],
            2
          ),
          _c(
            "button",
            {
              staticClass: "btn reveal-gate-btn reveal-query-submit-btn",
              staticStyle: { "min-width": "120px" },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("continue")
                },
              },
            },
            [_vm._v(" Continue ")]
          ),
        ]
      ),
      _vm.$slots.extra
        ? _c(
            "div",
            { staticClass: "reveal-gate-extra mt-2" },
            [_vm._t("extra")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }